import React from 'react'
import Select from 'react-select'
import { Option } from './Select'

interface Props {
  value: Period
  onChange: (key: string) => void
}
export enum Period {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
}

const periodOptions: Option[] = [
  { label: '日別', value: Period.Daily },
  { label: '週別', value: Period.Weekly },
  { label: '月別', value: Period.Monthly },
]

const PeriodSelector: React.FC<Props> = (props: Props) => {
  return (
    <>
      {/*@ts-ignore*/}
      <Select
        defaultValue={periodOptions[0]}
        value={periodOptions.find(option => option.value === props.value)}
        options={periodOptions}
        onChange={selectedOption => {
          if (selectedOption && 'value' in selectedOption) {
            props.onChange(selectedOption.value)
          }
        }}
      />
    </>
  )
}

export default PeriodSelector
